import React, { useMemo } from 'react';
import { DeviceActionProps } from '@components/Actions/ActionsModal/types';
import ActionTypes from '@utils/deviceActions';
import { useTranslation } from 'react-i18next';

interface CancellationWithdrawalPayloadProps {
  action: ActionTypes.CANCELLATION_SUSPENSION;
  devices: {
    msisdn: string;
  }[];
}

const useCancellationOfSuspension = (
  devices: {
    msisdn: string;
  }[],
): DeviceActionProps => {
  const { t } = useTranslation('actions-modal');

  const infoMessage = useMemo(
    () => <span>{t('suspension-withdrawal.cancellation-info-warning')}</span>,
    [t],
  );

  const payloadToSend = useMemo(
    (): CancellationWithdrawalPayloadProps => ({
      action: ActionTypes.CANCELLATION_SUSPENSION,
      devices,
    }),
    [devices],
  );

  return {
    steps: [],
    payloadToSend,
    infoMessage,
  };
};

export default useCancellationOfSuspension;
